var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VIcon',_vm._g(_vm._b({},'VIcon',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  mdi-"+_vm._s(_vm.iconName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }